import React from 'react';
import {
  Drawer,
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  Divider,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { featureFlag } from '../../featureFlags';
import { LanguageSwitcher } from '../../translation/tools/LanguageSwitcher';

interface AppBarNavigationDrawerDesktopProps {
  open: boolean | undefined;
  handleDrawerDesktopToggle?: () => void;
  drawerNavigationItems: any;
}

export function AppBarNavigationDrawerDesktop({
  handleDrawerDesktopToggle,
  open,
  drawerNavigationItems,
}: AppBarNavigationDrawerDesktopProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <Drawer
      variant="persistent"
      sx={{
        display: { xs: 'none', sm: 'block' },
        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
      }}
      open={open}
    >
      <Box
        sx={{
          padding: theme.spacing(0, 1),
          ...theme.mixins.toolbar,
        }}
      >
        <IconButton
          onClick={handleDrawerDesktopToggle}
          aria-label={t('accessibility.MENU_TOGGLE')}
        >
          <MenuIcon sx={{ fill: theme.palette.text.primary }} />
        </IconButton>
      </Box>

      <List>
        {drawerNavigationItems.map((item: any) => {
          return (
            <Box key={item.text}>
              <ListItemButton
                data-testid={item.text?.toLowerCase()}
                onClick={() => navigate(item.link)}
                sx={{ p: 2 }}
                selected={pathname.includes(item.link)}
              >
                {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                <ListItemText primary={item.text} />
              </ListItemButton>
              {item.withDivider && <Divider />}
            </Box>
          );
        })}
      </List>
      {featureFlag('languageSwitcher') && <LanguageSwitcher />}
    </Drawer>
  );
}
